import type { RequestConfig } from '@customTypes/index';
import type { ArtistLanguageDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistGetProfileLanguagesRequest = {
  profileId: string;
};

export type ArtistGetProfileLanguagesParams =
  RequestConfig<ArtistGetProfileLanguagesRequest>;

export const artistGetProfileLanguages = async ({
  params,
  config
}: ArtistGetProfileLanguagesParams) =>
  api.get<ArtistLanguageDto[]>(
    `/api/ArtistProfile/${params.profileId}/languages`,
    config
  );
